<template>
    <div style="height: 100vh;overflow: scroll">
        <ul class="gongneng">
            <li><h1>{{title}}</h1></li>
            <li>
                <el-button type="success" @click="this.$router.push('/backStage_Management/News')">公司新闻</el-button>
                <el-button type="primary" @click="this.$router.push('/backStage_Management/News/newsAdd')"> <i class="el-icon-circle-plus"></i>添加新闻</el-button>
            </li>
        </ul>


        <div class="table">

            <el-table
                    :data="tableData"

                    border
                    style="width: 100%">
                <el-table-column
                        prop="id"
                        label="编号"
                        width="">
                </el-table-column>
                <el-table-column
                        fixed
                        prop="catId"
                        label="分类"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="标题"
                        width="">
                </el-table-column>

                <el-table-column
                        prop="addTime"
                        label="添加日期"
                        width="">
                </el-table-column>

                <el-table-column
                        key="slot"
                        label="操作"
                        width="">
                    <template #default="{row}">

                        <el-button @click="handleClick(row)" type="text" size="small">修改</el-button>
                        <el-button @click="deleteClick(row)" type="text" size="small">删除</el-button>

                    </template>
                </el-table-column>

            </el-table>

        </div>


    </div>
</template>

<script>
    import request from "@/utils/request";
    export default {
        name: "new",
        data() {
            return{
                title:"行业新闻",
                total:"",
                tableData: [],

            }
        },
        methods: {

            getData(){
                request.get("/news_management/industryNews").then(res => {
                    alert(JSON.stringify(res.data()))
                    this.tableData=res.data;


                })
            },
            handleClick(row) {


                this.$router.push({path:"/backStage_Management/News/newsAdd",query:{id:row.id,title:this.title}})

            },
            deleteClick(row){

                this.$confirm('此操作将永久删除该型号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    request.delete("/news_management/"+this.title+"/"+row.catId).then(res => {
                        if (res.code==200){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getData()
                        }else {
                            this.$message({
                                type: 'warning',
                                message: '删除失败!'
                            });
                        }
                    })


                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });


            }
        },
        beforeMount() {
            this.getData()
        }


    }
</script>

<style lang="less" scoped>

    .el-menu{
        height:100vh
    }
    .gongneng{
        padding: 20px 0;
        border-bottom: 1px solid #cccccc;
        overflow: hidden;
        li:first-child{
            float: left;
            margin-left: 10px;
        }
        li:last-child{
            float: right;
            margin-right: 10px;
        }
    }
    .xiala{
        padding: 10px;
    }
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>